"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var ListingForm_1 = require("./ListingForm");
var mobx_1 = require("mobx");
var HostAppView_1 = require("@twii/core-ui-fabric/lib/component/HostAppView");
var ListingMenuHelper_1 = require("./ListingMenuHelper");
var ListingModelSupplier_1 = require("../model/ListingModelSupplier");
var ListingNavHelper_1 = require("./ListingNavHelper");
var ListingEditApp = /** @class */ (function (_super) {
    __extends(ListingEditApp, _super);
    function ListingEditApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onBack = function () {
            ListingNavHelper_1.popAndLoad(_this.host, { path: "/ozone/listings/" + _this.listingId });
        };
        _this._onSave = function (listing) {
            listing.save().then(_this._onBack).catch(function () {
                // we don't do anything here - the error should be reported on the model
            });
        };
        _this._onSaveImmediate = function () {
            _this._onSave(_this._listingSupplier.value);
        };
        _this._onSubmitForApproval = function (listing) {
            listing.submitForApproval().then(_this._onBack).catch(function () {
                // we don't do anything here - the error should be reported on the model
            });
        };
        return _this;
    }
    Object.defineProperty(ListingEditApp.prototype, "host", {
        get: function () {
            return this.props.match.host;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingEditApp.prototype, "userProfile", {
        get: function () {
            return this.props.match.userProfile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingEditApp.prototype, "listingId", {
        get: function () {
            return this.props.match.params.listingId;
        },
        enumerable: true,
        configurable: true
    });
    ListingEditApp.prototype.componentWillMount = function () {
        var _this = this;
        var s = new ListingModelSupplier_1.ListingModelSupplier(this.listingId);
        s.load();
        this._listingSupplier = s;
        this._titleSetDisposer = mobx_1.autorun(function () {
            _this.host.setTitle(s.sync.syncing ? "Loading..." : s.value ? s.value.title : undefined);
        });
    };
    ListingEditApp.prototype.componentWillUnount = function () {
        if (this._titleSetDisposer) {
            this._titleSetDisposer();
            delete this._titleSetDisposer;
        }
    };
    ListingEditApp.prototype.render = function () {
        var items = [];
        var backItem = ListingMenuHelper_1.createBackItem(this.host);
        if (backItem) {
            items.push(backItem);
        }
        items.push({
            key: "cancel",
            name: "Cancel",
            iconProps: {
                iconName: "Cancel"
            },
            onClick: this._onBack
        }, {
            key: "save",
            name: "Save",
            iconProps: {
                iconName: "Save"
            },
            disabled: this._listingSupplier.sync.syncing,
            onClick: this._onSaveImmediate
        });
        return (React.createElement(HostAppView_1.HostAppView, { host: this.host, commandBarProps: { items: items } },
            React.createElement(ListingForm_1.ListingFormContainer, { listingSupplier: this._listingSupplier, onSave: this._onSave, onSubmitForApproval: this._onSubmitForApproval, onCancel: this._onBack })));
    };
    ListingEditApp = __decorate([
        mobx_react_1.observer
    ], ListingEditApp);
    return ListingEditApp;
}(React.Component));
exports.ListingEditApp = ListingEditApp;
exports.default = ListingEditApp;
